import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "parametres-estimatif-client" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "Type de projet", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "Honoraires", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "Adresse des travaux", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "Commentaire", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "Marge", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "TVA", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_number_format = _resolveComponent("number-format")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_row, {
      type: "flex",
      gutter: 48
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _hoisted_2,
                    _createVNode(_component_a_form_item, {
                      label: "Objet des travaux",
                      "label-Col": {span: 6}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.internalEstimatifClient.projet,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.internalEstimatifClient.projet) = $event)),
                          maxlength: 255,
                          disabled: _ctx.estArchive
                        }, null, 8, ["value", "disabled"])
                      ]),
                      _: 1
                    }),
                    _hoisted_3,
                    _createVNode(_component_a_form_item, {
                      label: "Honoraires",
                      "label-Col": {span: 6}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_number, {
                          value: _ctx.internalEstimatifClient.honoraire,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.internalEstimatifClient.honoraire) = $event)),
                          min: "0",
                          disabled: _ctx.estArchive
                        }, null, 8, ["value", "disabled"])
                      ]),
                      _: 1
                    }),
                    _hoisted_4,
                    _createVNode(_component_a_form_item, {
                      label: "Adresse",
                      "label-Col": {span: 6}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.internalEstimatifClient.adresseConstruction,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.internalEstimatifClient.adresseConstruction) = $event)),
                          maxlength: 255,
                          disabled: _ctx.estArchive
                        }, null, 8, ["value", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_form_item, {
                      label: "Complément d'adresse",
                      "label-Col": {span: 6}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.internalEstimatifClient.adresseComplementConstruction,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.internalEstimatifClient.adresseComplementConstruction) = $event)),
                          maxlength: 255,
                          disabled: _ctx.estArchive
                        }, null, 8, ["value", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_form_item, {
                      label: "Code Postal",
                      "label-Col": {span: 6}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.internalEstimatifClient.codePostalConstruction,
                          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.internalEstimatifClient.codePostalConstruction) = $event)),
                          maxlength: 10,
                          disabled: _ctx.estArchive
                        }, null, 8, ["value", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_form_item, {
                      label: "Ville",
                      "label-Col": {span: 6}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.internalEstimatifClient.villeConstruction,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.internalEstimatifClient.villeConstruction) = $event)),
                          maxlength: 255,
                          disabled: _ctx.estArchive
                        }, null, 8, ["value", "disabled"])
                      ]),
                      _: 1
                    }),
                    _hoisted_5,
                    _createVNode(_component_a_form_item, {
                      label: "Commentaire",
                      "label-Col": {span: 6}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.internalEstimatifClient.commentaire,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.internalEstimatifClient.commentaire) = $event)),
                          maxlength: 255,
                          disabled: _ctx.estArchive
                        }, null, 8, ["value", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  span: 24,
                  align: "right"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: _ctx.updateParametrage,
                      disabled: _ctx.estArchive
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Sauvegarder ")
                      ]),
                      _: 1
                    }, 8, ["onClick", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _hoisted_6,
                    _createVNode(_component_a_alert, {
                      message: "Attention : Définir une marge écrasera toutes les marges déjà existantes dans l'estimatif.",
                      type: "info"
                    }),
                    _createVNode(_component_a_form_item, {
                      label: "Marge",
                      "label-Col": {span: 3}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_space, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input_number, {
                              value: _ctx.marge,
                              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.marge) = $event)),
                              min: 0,
                              controls: false,
                              decimalSeparator: ",",
                              "addon-after": "%",
                              placeholder: "Marge",
                              style: {"width":"110px"},
                              disabled: _ctx.estArchive
                            }, null, 8, ["value", "disabled"]),
                            _createVNode(_component_a_popconfirm, {
                              title: "Êtes-vous sûr de vouloir mettre à jour la marge ?",
                              onConfirm: _ctx.updateMarge,
                              "ok-text": "Oui",
                              "cancel-text": "Non"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, {
                                  type: "primary",
                                  disabled: _ctx.estArchive || _ctx.marge == null
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Sauvegarder ")
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            }, 8, ["onConfirm"]),
                            _createVNode(_component_a_popconfirm, {
                              title: "Êtes-vous sûr de vouloir réinitialiser la marge ?",
                              onConfirm: _ctx.resetMarge,
                              "ok-text": "Oui",
                              "cancel-text": "Non"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, {
                                  danger: "",
                                  ghost: "",
                                  disabled: _ctx.estArchive
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Réinitialiser ")
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            }, 8, ["onConfirm"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _hoisted_7,
                    _createVNode(_component_a_alert, {
                      message: "Attention : Définir une TVA écrasera toutes les TVA déjà existantes dans l'estimatif.",
                      type: "info"
                    }),
                    _createVNode(_component_a_form_item, {
                      label: "TVA",
                      "label-Col": {span: 3}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_space, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              value: _ctx.tvaId,
                              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.tvaId) = $event)),
                              placeholder: "TVA",
                              style: {"width":"110px"},
                              disabled: _ctx.estArchive
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select_option, { value: null }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("TVA")
                                  ]),
                                  _: 1
                                }),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tvas, (tva) => {
                                  return (_openBlock(), _createBlock(_component_a_select_option, {
                                    key: tva.tvaId,
                                    value: tva.tvaId
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_number_format, {
                                        value: tva.taux,
                                        options: _ctx.percentageValueOptions
                                      }, null, 8, ["value", "options"])
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["value", "disabled"]),
                            _createVNode(_component_a_popconfirm, {
                              title: "Êtes-vous sûr de vouloir mettre à jour la TVA ?",
                              onConfirm: _ctx.updateTva,
                              "ok-text": "Oui",
                              "cancel-text": "Non",
                              disabled: _ctx.estArchive || _ctx.tvaId == null
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, {
                                  type: "primary",
                                  disabled: _ctx.estArchive || _ctx.tvaId == null
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Sauvegarder ")
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            }, 8, ["onConfirm", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}